import React, { useState, useEffect, CSSProperties, FC } from "react"
import YouTube from 'react-youtube';
import Modal from '../components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons'
import Styles from "../styles/YouTubePlayerText.module.scss"
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const youtubeRegExp = /https?:\/\/(?:.+.)?youtube\.com\/watch\?v=([^&]+)/im
const shortYoutubeRegExp = /https?:\/\/(?:.+.)?youtu\.be\/([-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)(.*)/im

type Props = {
    videoURL: string,
    textStyle: CSSProperties
}

export const YoutubePlayerText: FC<Props> = ( {
    videoURL,
    textStyle
} ) => {

    const [ modalVisible, setModalVisible ] = useState( false )
    const [ videoID, setVideoID ] = useState( "" )

    useEffect( () => {
        if ( !videoURL ) return
        const shortMatch = videoURL.match( shortYoutubeRegExp )
        if ( shortMatch ) {
            setVideoID( shortMatch[ 1 ] )
            return
        }
        const match = videoURL.match( youtubeRegExp )
        if ( match ) {
            setVideoID( match[ 1 ] )
            return
        }
    }, [ videoURL ] )


    let startTime = videoURL ?
        videoURL.split( 't=' ).slice( -1 )[ 0 ] :
        0

    const options = {
        playerVars: {
            start: Number( startTime )
        }
    }

    // 短縮URLの時に上記optionsのstart設定が効かないため
    const onReady = ( event: { target: any } ) => {
        event.target.seekTo( startTime );
    }

    const displayModal = () => setModalVisible( true )

    return (
        <>
            <span onClick={ displayModal } style={ textStyle }>{ videoURL }</span>
            { videoID &&
                <div className={ Styles.thumbnail_container }>
                    <img
                        className={ Styles.thmbnail }
                        src={ `https://img.youtube.com/vi/${ videoID }/0.jpg` }
                        onClick={ displayModal } />
                    <FontAwesomeIcon
                        icon={ faPlayCircle as IconProp }
                        className={ Styles.play_icon }
                        onClick={ displayModal } />
                </div> }
            { modalVisible &&
                <Modal
                    visible={ modalVisible }
                    closeModal={ () => setModalVisible( false ) }>
                    <YouTube videoId={ videoID } className="youtube-player" opts={ options } onReady={ onReady } />
                </Modal> }
        </>
    )
}

